<div class="right_login">
	<div class="content_form" *ngIf="!showSucces">
		<h1>Validación de datos</h1>
		<div class="tab-slider--container">
			<div class="usuario_contrasena center_content">
				<label class="igresa_tu_dni">Leer y responder correctamente</label>
			</div>

			<form #myform="ngForm">
				<div class="content_acordeon">
					<div *ngFor="let item of securityQuestions">
						<div class="dat_1">
							<div class="field_espacio">
								<label>{{ item.description }}</label>
								<div class="content_radios" *ngIf="!item.description.includes('fecha'); else fechainput">
									<label class="container_radio">
										<input
											type="radio"
											value="1"
											id="q1"
											[name]="item.idquestion"
											[(ngModel)]="item.answer"
											checked="checked_radio"
											required
										/>
										<span class="checkmark_radio"></span>
										si
									</label>
									<label class="container_radio">
										<input type="radio" value="0" id="q2" [name]="item.idquestion" [(ngModel)]="item.answer" required />
										<span class="checkmark_radio"></span>
										no
									</label>
								</div>
								<ng-template class="content_radios" #fechainput>
									<input
										type="date"
										[name]="item.idquestion"
										class="form_element icon_calendario"
										[(ngModel)]="item.answer"
										required
									/>
								</ng-template>
							</div>
						</div>
					</div>
				</div>
			</form>
			<div class="message_error" *ngIf="showError">
				<label class="error">
					{{ errorMessageResponse }}
				</label>
			</div>
		</div>
		<fieldset class="center_content request_password">
			<button type="button" name="previous" class="button_valid previous_paso" (click)="back()">ANTERIOR</button>
			<button
				type="submit"
				name="next"
				class="next_paso button_valid"
				(click)="onClick()"
				[ngClass]="{ btn_conf: true }"
			>
				CONTINUAR
			</button>
		</fieldset>
	</div>
	<!-- fin de pantalla de validación -->
	<!-- pantalla de confirmacion de envio al correo -->
	<div class="content_form" *ngIf="showSucces">
		<h1>Confirmación de solicitud de contraseña</h1>
		<div class="tab-slider--container">
			<div class="usuario_contrasena" *ngIf="showSucces">
				<div class="revisar_correo" *ngIf="showSucces">
					<app-alert
						title="¡Listo!"
						message="Te enviamos un correo con todos los detalles de la solicitud de contraseña."
						type="succes"
					></app-alert>
					<div class="center_content">
						<p><strong>Correo electronico</strong></p>
					</div>
					<div class="center_content">
						<p>{{ userData.email }}</p>
					</div>
					<div class="center_content">
						<p><strong>Fecha y hora</strong></p>
					</div>
					<div class="center_content">
						<p>{{ responseValidateQuestions.fechaHoraResponse }}</p>
					</div>
					<div class="center_content no_recibi_correo">
						<p>En caso haya problemas con la generación de su contraseña, enviar un correo a mobile@cp.com.pe</p>
					</div>
					<div class="center_content">
						<button class="boton_ingresar" [routerLink]="['/login']">SALIR</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
